import React from 'react';
import { SectionHeader, AtriumLine, Button, FadeIn } from '../ui';
export function Awards() {
  const awards = [{
    year: '2025',
    title: 'MBA Finalist, Best Contract Home $1M to $2M',
    home: 'Kinross'
  }, {
    year: '2024',
    title: 'HIA Winner, Custom Built Home $1.2M to $1.7M',
    home: 'Armstrong Residence'
  }, {
    year: '2024',
    title: 'HIA Finalist, Custom Built Home of the Year',
    home: null
  }, {
    year: '2024',
    title: 'MBA Winner, Best Contract Home $540k to $660k',
    home: null
  }, {
    year: '2022',
    title: 'MBA Winner, Best Display Home',
    home: 'The Long Island'
  }];
  return <section id="awards" className="py-16 md:py-24 bg-white scroll-mt-24" data-id="element-79">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-80">
        <FadeIn data-id="element-81">
          <SectionHeader eyebrow="Recognition" title="Award-winning, decade after decade" className="text-center mb-16" data-id="element-82" />
        </FadeIn>

        <div className="relative border-l border-atrium-bronze/30 ml-4 md:ml-0 md:border-l-0" data-id="element-83">
          {/* Desktop central line */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[1px] bg-atrium-bronze/30" data-id="element-84" />

          {awards.map((award, index) => <FadeIn key={index} delay={index * 100} data-id="element-85">
              <div className={`relative flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pl-8 md:pl-0 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-86">
                {/* Timeline Node */}
                <div className="absolute left-[-5px] md:left-1/2 md:-translate-x-1/2 w-2.5 h-2.5 bg-atrium-bronze rounded-sm rotate-45 mt-1.5 md:mt-0" data-id="element-87" />

                {/* Content */}
                <div className={`w-full md:w-[45%] ${index % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-88">
                  <span className="block text-sm font-bold text-atrium-green mb-2" data-id="element-89">
                    {award.year}
                  </span>
                  <h4 className="font-serif text-lg text-atrium-ink leading-snug" data-id="element-90">
                    {award.title}
                    {award.home && <span className="block text-sm font-sans font-normal text-atrium-ink/60 mt-1" data-id="element-91">
                        ({award.home})
                      </span>}
                  </h4>
                </div>

                {/* Empty space for alternating layout */}
                <div className="hidden md:block w-[45%]" data-id="element-92" />
              </div>
            </FadeIn>)}

          <FadeIn delay={500} data-id="element-93">
            <div className="relative flex flex-col md:flex-row items-start md:items-center justify-center mt-16 pl-8 md:pl-0" data-id="element-94">
              <div className="absolute left-[-5px] md:left-1/2 md:-translate-x-1/2 w-2.5 h-2.5 border border-atrium-bronze bg-white rounded-sm rotate-45 mt-1 md:mt-0" data-id="element-95" />
              <p className="text-sm font-medium text-atrium-ink/60 italic text-center md:bg-white md:px-4 md:relative md:z-10" data-id="element-96">
                Recognised by HIA & MBA since 1995
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="mt-16 text-center" data-id="element-97">
          <Button variant="secondary" as="a" href="/awards/" data-id="element-98">
            Explore all awards
          </Button>
        </div>
      </div>
    </section>;
}